import axios from 'axios'
import store from '@/store'
export default () => {
  return axios.create({
    //baseURL: `https://dw.consolidacion.complementservices.com/api/`,
    //baseURL: `http://localhost:7280/api/`,
    //baseURL: `http://backendapi.eastus.cloudapp.azure.com:7480/api/`,
    //baseURL: `https://172.171.75.97:7400/api/`,
    baseURL: `https://bkit.complement-it.com:7400/api/`,
    //baseURL: `http://10.0.0.197:7480/api/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}
